
const enterFullscreen = (tableRef) => {
  const elem = tableRef.current;
  if (elem?.requestFullscreen) {
    elem?.requestFullscreen();
  } else if (elem?.mozRequestFullScreen) {
    elem?.mozRequestFullScreen();
  } else if (elem?.webkitRequestFullscreen) {
    elem?.webkitRequestFullscreen();
  }
};

const exitFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }
};

export const fullPageView = (tableRef, setFullScreenEnabled) => {
  if (!document.fullscreenElement) {
    enterFullscreen(tableRef);
    setFullScreenEnabled(true);
  } else {
    exitFullscreen();
    setFullScreenEnabled(false);
  }
};
